import type {
  PortalOperation,
  PortalOperationIcon,
  PortalOperationList,
  PortalOperationPageResponse,
  PortalOperationResponse,
} from '../types/portal.types';

const icons = new Set<PortalOperationIcon>([
  'project', 'plan', 'material', 'monitor',
  'form', 'report', 'settings',
]);

export function operationIdentity(
  applicationCode: string,
  operationCode: string,
) {
  return `${applicationCode}:${operationCode}`;
}

export function operationRoute(operation: Pick<
  PortalOperationResponse,
  'applicationCode' | 'operationCode'
>) {
  return `/portal/operations/${encodeURIComponent(operation.applicationCode)}/${encodeURIComponent(operation.operationCode)}`;
}

export function mapOperation(
  operation: PortalOperationResponse,
): PortalOperation {
  return {
    operationId: operationIdentity(
      operation.applicationCode, operation.operationCode,
    ),
    applicationCode: operation.applicationCode,
    operationCode: operation.operationCode,
    name: operation.name,
    description: operation.description ?? '',
    systemCode: operation.sourceApplication.applicationCode,
    systemName: operation.sourceApplication.applicationName,
    listId: operation.groupCode,
    icon: icons.has(operation.icon)
      ? operation.icon : 'settings',
    routePath: operationRoute(operation),
    pageRoute: operation.pageRoute,
    sourceKind: operation.sourceKind,
    availableActions: operation.availableActions,
    enabled: operation.availability.available,
    availabilityCode: operation.availability.code,
    unavailableReason: operation.availability.available
      ? undefined : operation.availability.message,
    favorite: operation.favorite,
    favoriteSortNo: operation.favoriteSortNo,
  };
}

export function mapOperationLists(
  page: PortalOperationPageResponse,
): PortalOperationList[] {
  return page.groups.map(group => {
    const operations = group.operations.map(mapOperation);
    const applications = new Set(
      operations.map(operation => operation.systemName),
    );
    return {
      listId: group.groupCode,
      name: group.groupName,
      systemCode: group.defaultGroup ? 'DEFAULT' : 'MIXED',
      systemName: applications.size === 1
        ? [...applications][0]! : '跨应用操作',
      sort: group.sortNo,
      operations,
    };
  });
}
